import React from 'react';
import { PILLARS } from '../data/content';
import { Overline } from './Overline';
export function SolutionSection() {
  return <section id="sistema" className="bg-charcoal py-24 text-cream lg:py-32" data-id="element-328" data-mp="3aaub3dpcj7ed">
      <div className="mx-auto max-w-content px-6 lg:px-10" data-id="element-329" data-mp="3o9k9cwnwjd4b">
        <div className="max-w-3xl" data-id="element-330" data-mp="3o6xvkfaf41dn">
          <Overline tone="light" data-id="element-331" data-mp="3j9xvcl091sug">El método</Overline>
          <h2 className="mt-6 font-serif text-[2.2rem] font-light leading-[1.1] sm:text-[3rem]" data-id="element-332" data-mp="3jck4gp2sgges">
            Por eso creamos el Sistema Suelo Perfecto™
          </h2>
          <p className="mt-6 text-[15px] leading-relaxed text-cream/70" data-id="element-333" data-mp="3t7lq3axuv0cm">
            Un método de trabajo diseñado para que sepas qué se hará, cuánto puede costar, cuánto
            tardará y cómo quedará antes de empezar.
          </p>
        </div>

        <div className="mt-16 grid gap-px bg-cream/15 lg:grid-cols-3" data-id="element-334" data-mp="ksbv0msduvec">
          {PILLARS.map(pillar => <article key={pillar.index} className="group flex flex-col bg-charcoal p-8 transition-colors duration-200 ease-premium hover:bg-[#443c34] lg:p-10" data-id="element-335" data-mp="fu0ke9u9kgv2">
              <span className="font-serif text-2xl text-champagne" data-id="element-336" data-mp="3b971zf84r5p8">{pillar.index}</span>
              <h3 className="mt-6 font-serif text-2xl font-light leading-snug" data-id="element-337" data-mp="3fbk5ry3bgtjd">{pillar.title}</h3>
              <p className="mt-4 text-[13.5px] leading-relaxed text-cream/65" data-id="element-338" data-mp="3ka59w8lovxd3">{pillar.text}</p>
            </article>)}
        </div>

        <figure className="mt-20 border-t border-cream/15 pt-12 text-center" data-id="element-339" data-mp="3p8osbz12qr0p">
          <blockquote className="mx-auto max-w-3xl font-serif text-[1.7rem] font-light leading-snug text-cream sm:text-[2.2rem]" data-id="element-340" data-mp="3u7rsp664092c">
            “La diferencia entre poner parquet y transformar una casa está en los detalles.”
          </blockquote>
          <figcaption className="mt-6 text-[11px] uppercase tracking-overline text-champagne" data-id="element-341" data-mp="6xla6xk9ba6e">
            Lussonovo · Barcelona
          </figcaption>
        </figure>
      </div>
    </section>;
}